import { useQuery } from '@tanstack/react-query'
import type { OrpcClient } from '@/orpc/client'
import { useOrpc } from './useClient'

export type PractitionerDetail = Awaited<ReturnType<OrpcClient['getPractitioner']>>

/**
 * One Org Member for the Provider Operations detail page (`getPractitioner`): the list row
 * plus the Organization the caller may manage them in. The middleware refuses a
 * practitioner outside the caller's scope. `organizationId` is the Organization the page
 * was opened from; it only picks between the roles of a member in more than one.
 */
export function usePractitioner(practitionerId: string | undefined, organizationId?: string) {
  const orpc = useOrpc()
  return useQuery(
    orpc.getPractitioner.queryOptions({
      input: {
        practitionerId: practitionerId ?? '',
        ...(organizationId ? { organizationId } : {}),
      },
      enabled: Boolean(practitionerId),
    }),
  )
}
